/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Classification_EditorInputs */

const en_page_title_classification_editor = /** @type {(inputs: Page_Title_Classification_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classification editor`)
};

const nl_page_title_classification_editor = /** @type {(inputs: Page_Title_Classification_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificatie-editor`)
};

/**
* | output |
* | --- |
* | "Classification editor" |
*
* @param {Page_Title_Classification_EditorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_classification_editor = /** @type {((inputs?: Page_Title_Classification_EditorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Classification_EditorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_classification_editor(inputs)
	return en_page_title_classification_editor(inputs)
});